import IsaasIntegration from "./IsaasIntegration.js";

/**
 * `UnicontaIsaasIntegration` is a concrete implementation of `AbstractIntegration`
 * for integration with Uniconta using iSaaS.
 */
export default class UnicontaIsaasIntegration extends IsaasIntegration {
	getName() {
		return "Uniconta";
	}

	routeName() {
		return "isaas-uniconta";
	}

	static getType() {
		return "UnicontaIsaasIntegration";
	}
}
